import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const PurchaseDateLoginEnableSchema = Yup.object().shape({
  orderReference: Yup.string().required(globalMessages.form.required),
  purchaseDate: Yup.date().required(globalMessages.form.required),
});

export default PurchaseDateLoginEnableSchema;
